const PROVIDER_NONE = 'none';
const PROVIDER_HCAPTCHA = 'hcaptcha';
const PROVIDER_CAP = 'cap';

const normaliseCaptchaProvider = (value) => {
    if (typeof value !== 'string') return '';
    const normalised = value.trim().toLowerCase();
    return [PROVIDER_NONE, PROVIDER_HCAPTCHA, PROVIDER_CAP].includes(normalised) ? normalised : '';
};

const resolveCaptchaProvider = ({context = {}, rules = {}} = {}) => {
    if (context?.captchaEnabled === false) return PROVIDER_NONE;
    const formProvider = normaliseCaptchaProvider(rules?.captchaProvider);
    const globalProvider = normaliseCaptchaProvider(context?.captchaProvider);
    return formProvider
        || globalProvider
        || (context?.capApiEndpoint ? PROVIDER_CAP : '')
        || (context?.hcaptchaSiteKey ? PROVIDER_HCAPTCHA : PROVIDER_NONE);
};

module.exports = {
    PROVIDER_NONE,
    PROVIDER_HCAPTCHA,
    PROVIDER_CAP,
    normaliseCaptchaProvider,
    resolveCaptchaProvider,
};
module.exports.default = module.exports;
